'use client';

import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { APP_CONSTANTS } from 'packages/frontend/src/constants/app.constants';

interface HeroSectionProps {
  guardianLoginUrl: string;
}

export function HeroSection({ guardianLoginUrl }: HeroSectionProps) {
  return (
    <div className="bg-[#F5F8F9] rounded-xl text-center space-y-6 sm:space-y-8 lg:space-y-10 px-3 xs:px-4 sm:px-6 md:px-8 pt-12 xs:pt-16 sm:pt-20 md:pt-24 lg:pt-28 xl:pt-32 pb-10 xs:pb-12 sm:pb-16 md:pb-20 lg:pb-24 xl:pb-28 mx-2 sm:mx-4 lg:mx-8">
      <div className="space-y-4 sm:space-y-6 lg:space-y-8">
        <h1 className="text-2xl xs:text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight">
          <span className="block text-[#0D373D]">Give teachers time back</span>
          <span className="block mt-1 xs:mt-1.5 sm:mt-2 md:mt-3 text-[#1D2125]">
            Run your school from{' '}
            <span className="inline-block px-2 xs:px-2.5 sm:px-3 py-0.5 xs:py-1 bg-[#E2FDCB] text-[#0D373D] rounded text-lg xs:text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold">One Nest</span>
          </span>
        </h1>
        <p className="text-sm xs:text-base sm:text-lg md:text-xl lg:text-2xl text-[#4D4F52] max-w-xs xs:max-w-sm sm:max-w-2xl md:max-w-3xl lg:max-w-4xl mx-auto leading-relaxed px-2 xs:px-4 sm:px-0">
          {APP_CONSTANTS.APP_NAME} by {APP_CONSTANTS.BRAND_NAME} is the school's operating system, beautifully tying together all core administrative tasks. Fast for teachers. Clear for leadership. Effortless for parents.
        </p>
      </div>

      {/* CTA Buttons */}
      <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center pt-4 sm:pt-6 lg:pt-8 px-2 xs:px-4 sm:px-0">
        <Link
          href="/login"
          className="w-full xs:w-full sm:w-auto min-w-[160px] xs:min-w-[180px] flex items-center justify-center px-3 xs:px-4 py-2 xs:py-2.5 bg-[#0D373D] hover:bg-[#0A2A2F] text-white text-sm xs:text-base font-semibold rounded-xl transition-colors"
        >
          Admin & staff login
          <ArrowRight className="ml-1.5 xs:ml-2 h-3 xs:h-4 w-3 xs:w-4" />
        </Link>
        <a
          href={guardianLoginUrl}
          className="w-full xs:w-full sm:w-auto min-w-[160px] xs:min-w-[180px] flex items-center justify-center px-3 xs:px-4 py-2 xs:py-2.5 bg-white text-[#0D373D] border-2 border-[#0D373D] hover:bg-[#F5F8F9] text-sm xs:text-base font-semibold rounded-xl transition-colors"
        >
          Guardian login
          <ArrowRight className="ml-1.5 xs:ml-2 h-3 xs:h-4 w-3 xs:w-4" />
        </a>
      </div>
    </div>
  );
}

